import styled, { css } from "styled-components";

import { DesignTokens, Text } from "melco-ui";
import { textColorLookup } from "../../../helper/reportingHelper";
import { isEmpty } from "lodash-es";

const { spacings, fonts, colors } = DesignTokens;

const StyledText = styled(Text).withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
})<Pick<MachineNameProps, "status">>`
  color: ${colors.gray.dark};
  font-family: ${fonts.sansSerifMd};
  margin-right: ${spacings.xsmall}px;
  ${({ status }) => {
    const textColor = textColorLookup[status];

    if (!isEmpty(textColor)) {
      return css`
        && {
          color: ${textColor};
        }
      `;
    }
  }}
`;

type MachineNameProps = {
  name: string;
  status: any;
};

export const MachineName: React.FC<MachineNameProps> = ({ name, status }) => {
  return (
    <StyledText
      data-cy-id="machine-name"
      status={status}
      ellipsis={{ tooltip: name }}
    >
      {name}
    </StyledText>
  );
};
